// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '7f7de7a',
    builtAt: '2026-08-21T14:12:12.743Z',
} as const;
